import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '../auth/session';
import { ContestEntryDetailPage } from '../pages/contests/contest-entry-detail-page';

export const Route = createFileRoute('/contests/$id/entries/$entryId')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: function ContestEntryDetailRoute() {
    const { id, entryId } = Route.useParams();
    return <ContestEntryDetailPage contestId={id} entryId={entryId} />;
  },
});
